jQuery(document).ready(function($) {

    if( $('.block-hero-image-carousel').length ) {

        $('.block-hero-image-carousel').each(function() {
            startCarousel($(this));
        });

    }

    function startCarousel($container) {
        var $items = $container.find('ul li');
        if (!$items.length) return;

        var currentIndex = $items.index($items.filter('.is-active'));
        if (currentIndex === -1) {
            currentIndex = 0;
            $items.removeClass('is-active').eq(0).addClass('is-active');
        }

        var intervalMs = 5000;
        setInterval(function() {
            $items.eq(currentIndex).removeClass('is-active');
            currentIndex = (currentIndex + 1) % $items.length;
            $items.eq(currentIndex).addClass('is-active');
        }, intervalMs);
    }

});